import { Box, styled } from "@material-ui/core";
import { epocusTheme } from "../../_lib/epocus-theme-provider";

export const AdminPageRoot = styled(Box)({
  padding: 16,
  display: "flex",
  flexDirection: "column",
  gap: 16,
  maxWidth: 800,
  margin: "0 auto",
  [epocusTheme.breakpoints.up("sm")]: {
    padding: 24,
  },
});

export const AdminLoadingRow = styled(Box)({
  display: "flex",
  justifyContent: "center",
  padding: 24,
});
